var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileProfileDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FFD9E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 14.7917C20.625 16.2416 19.4498 17.4167 18 17.4167C16.5502 17.4167 15.375 16.2416 15.375 14.7917C15.375 13.3419 16.5502 12.1667 18 12.1667C19.4498 12.1667 20.625 13.3419 20.625 14.7917Z",
    fill: "#FF6291"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 18C16.9725 18.0057 15.9721 18.3295 15.1365 18.927C14.3007 19.5246 13.6708 20.3664 13.3331 21.3367C13.1842 21.7741 13.2559 22.2565 13.5256 22.6317C13.7992 23.0118 14.2357 23.2409 14.704 23.25H21.2956C21.7721 23.2482 22.2189 23.0184 22.4973 22.6317C22.7592 22.2525 22.8221 21.7704 22.6665 21.3367C22.3289 20.3664 21.6989 19.5246 20.8632 18.927C20.0275 18.3295 19.0271 18.0056 17.9998 18Z",
    fill: "#FF6291"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileProfileDropdown);
export default __webpack_public_path__ + "static/media/profile_profileDropdown.391bff14fd6130233494e7d5e0216bff.svg";
export { ForwardRef as ReactComponent };